import { MapContainer, TileLayer, Polyline, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect, useRef } from "react";
import "leaflet/dist/leaflet.css";

function stopIcon(n, kind) {
  // kind: "start" | "end" | "mid"
  const bg = kind === "start" ? "#16a34a" : kind === "end" ? "#dc2626" : "#0f766e";
  return L.divIcon({
    className: "route-stop-marker",
    html: `<div style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:${bg};color:#fff;font-size:12px;font-weight:700;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);">${n}</div>`,
    iconSize: [26, 26], iconAnchor: [13, 13], popupAnchor: [0, -14],
  });
}

function FitToRoute({ points }) {
  const map = useMap();
  const done = useRef(false);
  useEffect(() => {
    if (done.current || !points.length) return;
    try {
      if (points.length === 1) map.setView(points[0], 16);
      else map.fitBounds(L.latLngBounds(points), { padding: [36, 36], maxZoom: 16 });
      done.current = true;
    } catch { /* map not ready */ }
  }, [points, map]);
  return null;
}

export default function RouteMap({ route = [], stops = [], height = 320 }) {
  const pts = route.length ? route : stops.map((s) => [s.lat, s.long]);
  if (!pts.length) {
    return (
      <div data-testid="route-map-empty" className="flex items-center justify-center rounded-tenant-button border border-dashed border-tenant-border text-sm text-muted-foreground" style={{ height }}>
        No GPS track recorded for this day yet.
      </div>
    );
  }
  return (
    <div className="overflow-hidden rounded-tenant-button border border-tenant-border" style={{ height }}>
      <MapContainer center={pts[0]} zoom={14} scrollWheelZoom={false} className="h-full w-full" data-testid="route-map">
        <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" maxZoom={19} />
        {route.length > 1 && <Polyline positions={route} pathOptions={{ color: "#2563eb", weight: 4, opacity: 0.85 }} />}
        {stops.map((s, i) => {
          const kind = i === 0 ? "start" : i === stops.length - 1 ? "end" : "mid";
          return (
            <Marker key={`${s.lat}-${s.long}-${i}`} position={[s.lat, s.long]} icon={stopIcon(i + 1, kind)}>
              <Popup>
                <div style={{ minWidth: 160 }}>
                  <p style={{ fontWeight: 700, margin: 0 }}>{i + 1}. {s.place || "Stop"}</p>
                  {s.address && <p style={{ margin: "3px 0 0", fontSize: 12, color: "#666" }}>{s.address}</p>}
                  <p style={{ margin: "4px 0 0", fontSize: 12, color: "#0f766e", fontWeight: 600 }}>Stayed ~{s.dwell_min} min</p>
                </div>
              </Popup>
            </Marker>
          );
        })}
        <FitToRoute points={pts} />
      </MapContainer>
    </div>
  );
}
